
import React from 'react';
import styles from './HomePage.module.css';
import HeroSection from '../../components/HeroSection';
import RotatingBanner from '../../components/RotatingBanner';
import Features from '../../components/Features';
import PricingSection from '../../components/PricingSection';
import Testimonials from '../../components/Testimonials';
import FAQSection from '../../components/FAQSection';
import { useAuth } from '../../auth/AuthContext';

function Homepage() {
  const { loading } = useAuth();

  if (loading) {
    return <div className="spinner-container"><div className="spinner" /></div>;
  }

  return (
    <>
      <div className={styles.container}>
        <HeroSection />
      </div>
      <div className={styles.rotatingBannerWrapper}>
        <RotatingBanner />
      </div>
      <div className={styles.container}>
        <PricingSection />
      </div>
      <div className={styles.rotatingBannerWrapper}>
        <Testimonials />
      </div>
      <div className={styles.rotatingBannerWrapper}>
        <Features />
      </div>
      <div className={styles.container}>
        <FAQSection />
      </div>
    </>
  );
}

export default Homepage;
